export const GET_POPULAR = "GET_POPULAR";
export const GET_BACKDROP = "GET_BACKDROP";
export const GET_GAME_DATA = "GET_GAME_DATA";
